/** The phone warnings bar's folded line (layout/WarningsBar.tsx): "⚠ 3 warnings · 2 notes". */
export function foldedSummary(warnings: number, notes: number): string {
  const n = (count: number, word: string) => `${count} ${word}${count === 1 ? "" : "s"}`;
  if (warnings === 0) return `ⓘ ${n(notes, "note")}`;
  return `⚠ ${n(warnings, "warning")}${notes > 0 ? ` · ${n(notes, "note")}` : ""}`;
}
